<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>音视频课程管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/courseTypeListOO')">课程分类列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='分类名称'>
            <el-input
              clearable
              style="width:500px"
              v-model="filters.keyword"
              placeholder="请输入分类名称搜索"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="上架状态">
            <el-select
              v-model="filters.status"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="待上架"
                value="1"
              ></el-option>
              <el-option
                label="已上架"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              v-if="backFirst == 2"
              type="warning"
              @click="backFirstM"
            >返回返回上级</el-button>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
            <el-button v-if="hasPower('90019991')"
              type="success"
              @click="addPostDialog"
            >新增</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="id"
            label="编号"
          >
          </el-table-column>
          <el-table-column
            label="分类名称"
            prop="title"
          >
          </el-table-column>

          <el-table-column
            label="排序值"
            prop="orderIndex"
          >
          </el-table-column>

          <!-- <el-table-column label="首页展示图片">
            <template slot-scope="scope">
              <el-popover
                placement="top"
                title=""
                trigger="hover"
              >
                <img
                  style="max-height: 800px;max-width: 300px"
                  :src="scope.row.listPic"
                />
                <img
                  slot="reference"
                  :src="scope.row.listPic"
                  :alt="scope.row.listPic"
                  style="max-height: 50px;max-width: 130px"
                >
              </el-popover>

            </template>
          </el-table-column>

          <el-table-column label="筛选顶部图片">
            <template slot-scope="scope">

              <el-popover
                placement="top"
                title=""
                trigger="hover"
              >
                <img
                  style="max-height: 800px;max-width: 300px"
                  :src="scope.row.mainPic"
                />
                <img
                  slot="reference"
                  :src="scope.row.mainPic"
                  :alt="scope.row.mainPic"
                  style="max-height: 50px;max-width: 130px"
                >
              </el-popover>

            </template>
          </el-table-column> -->

          <el-table-column
            prop="status"
            label="上架状态"
          >
            <template slot-scope="scope">

              <el-tag
                v-if="scope.row.status == 1"
                type="success"
                disable-transitions
              >待上架</el-tag>
              <el-tag
                v-if="scope.row.status == 2"
                type="info"
                disable-transitions
              >已上架</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                v-if="hasPower('90019991') && scope.row.title != '全部' && scope.row.status == 1"
                @click="upHouseStatus(scope.row, 2)"
                type="text"
                size="small"
              >上架</el-button>
              <el-button
                v-if="hasPower('90019991') && scope.row.title != '全部' && scope.row.status == 2"
                @click="upHouseStatus(scope.row, 1)"
                type="text"
                size="small"
              >取消上架</el-button>
              <el-button v-if="hasPower('90019991')"
                @click="editPostDialog(scope.row)"
                type="text"
                size="small"
              >编辑</el-button>
              <el-button
                v-if="hasPower('90019991') && scope.row.title != '全部'"
                @click="upHouseStatus(scope.row, 3)"
                type="text"
                size="small"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="修改音视频分类"
      :visible.sync="dialogEditVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
        <el-form-item

          label="分类名称"
          prop='typeName'
        >
          <el-input :disabled="form.typeName != '全部' ? false : true" v-model="form.typeName"></el-input>
        </el-form-item>
        <el-form-item
          label="排序值"
          prop='index'
        >
          <el-input v-model="form.index"  type="number"></el-input>
        </el-form-item>
        <!-- <el-form-item
          v-if="form.pid != null"
          label="上级分类"
          v-loading="loading"
        >
          <el-select
            v-model="form.pid"
            placeholder="无上级分类"
          >
            <el-option
              v-for="option in typeOptions"
              :value="option.id"
              :key='option.id'
              :label="option.typeName"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <!-- <el-form-item
          label="列表显示图片"
          prop="listPic"
        >
          <el-upload
            class="avatar-uploader"
            action="/manager/user/seven_app_file_up"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :data='tokenData'
          >
            <img
              v-if="form.listPic"
              :src="form.listPic"
              class="avatar"
            >
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
            ></i>
            <div
              slot="tip"
              class="el-upload__tip"
            >只能上传jpg/png文件，图片比例：375px*210px</div>
          </el-upload>
        </el-form-item>

        <el-form-item
          label="筛选顶部图片"
          prop="listPic"
        >
          <el-upload
            class="avatar-uploader"
            action="/manager/user/seven_app_file_up"
            :show-file-list="false"
            :on-success="handleAvatarSuccess1"
            :before-upload="beforeAvatarUpload1"
            :data='tokenData'
          >
            <img
              v-if="form.mainPic"
              :src="form.mainPic"
              class="avatar"
            >
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
            ></i>
            <div
              slot="tip"
              class="el-upload__tip"
            >只能上传jpg/png文件，图片比例：375px*210px</div>
          </el-upload>
        </el-form-item> -->

        <el-form-item
          label="上架状态"
          prop="status"
        >
          <el-select
            :disabled="form.typeName != '全部' ? false : true"
            v-model="form.status"
            placeholder="请选择"
          >
            <el-option
              v-for="option in options"
              :value="option.value"
              :key='option.value'
              :label="option.text"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="editPost()"
            :loading="addLoading"
          >修改</el-button>
          <el-button @click="dialogEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="新增音视频分类"
      :visible.sync="dialogAddVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
        <el-form-item
          label="分类名称"
          prop='typeName'
        >
          <el-input v-model="form.typeName"></el-input>
        </el-form-item>
        <el-form-item
          label="排序值"
          prop='index'
        >
          <el-input v-model="form.index" type="number"></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="上级分类"
          v-loading="loading"
        >
          <el-select
            v-model="form.pid"
            placeholder="无上级分类"
          >
            <el-option
              v-for="option in typeOptions"
              :value="option.id"
              :key='option.id'
              :label="option.typeName"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <!-- <el-form-item
          label="列表显示图片"
          prop="listPic"
        >
          <el-upload
            class="avatar-uploader"
            action="/manager/user/seven_app_file_up"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :data='tokenData'
          >
            <img
              v-if="form.listPic"
              :src="form.listPic"
              class="avatar"
            >
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
            ></i>
            <div
              slot="tip"
              class="el-upload__tip"
            >只能上传jpg/png文件，图片比例：375px*210px</div>
          </el-upload>
        </el-form-item>

        <el-form-item
          label="筛选顶部图片"
          prop="listPic"
        >
          <el-upload
            class="avatar-uploader"
            action="/manager/user/seven_app_file_up"
            :show-file-list="false"
            :on-success="handleAvatarSuccess1"
            :before-upload="beforeAvatarUpload1"
            :data='tokenData'
          >
            <img
              v-if="form.mainPic"
              :src="form.mainPic"
              class="avatar"
            >
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
            ></i>
            <div
              slot="tip"
              class="el-upload__tip"
            >只能上传jpg/png文件，图片比例：375px*210px</div>
          </el-upload>
        </el-form-item> -->

        <el-form-item label="上架状态">
          <el-select
            v-model="form.status"
            placeholder="请选择"
          >
            <el-option
              v-for="option in options"
              :value="option.value"
              :key='option.value'
              :label="option.text"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="addPost()"
            :loading="addLoading"
          >新增</el-button>
          <el-button @click="dialogAddVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
export default {
  name: "judgeTypeList",
  created() {},

  data() {
    return {
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      addFormRule: {
        typeName: [
          { required: true, message: "请输入分类名称", trigger: "blur" }
        ],
        status: [
          { required: true, message: "请选择上架状态", trigger: "blur" }
        ],index: [
          { required: true, message: "请输入权重", trigger: "blur" }
        ],
        // listPic: [
        //   { required: true, message: "请上传首页列表图片", trigger: "blur" }
        // ],
        // mainPic: [
        //   { required: true, message: "请上传筛选顶部图片", trigger: "blur" }
        // ],
      },
      addLoading: false,
      loading: false,
      form: {
        infoType:8,
        status: null,
        typeName: null,
        index:null,
        pid: null,
        mainPic: null,
        listPic: null,
        id: null
      },
      dialogPics: [],
      dialogEditVisible: false,
      dialogContent: "",
      dialogTitle: "",
      dialogVisible: false,
      filters: {
        status: null,
        keyword: null,
        pid: null
      },
      isCollapse: true,
      activeName: "second",
      dialogAddVisible: false,
      backFirst: 1,
      page_num: 1,
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: [{ text: "待上架", value: "1" }, { text: "上架", value: "2" }],
      typeOptions: null,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    beforeAvatarUpload: function(e) {},
    beforeAvatarUpload1: function(e) {},
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.listPic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess1: function(e) {
      if (e.key == 1000) {
        this.form.mainPic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    addPost() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.noVip=1;
          para.token = localStorage.getItem("api_token");
          that.addLoading = true;
          API.up_add_good_type(para)
            .then(
              function(result) {
                that.$refs["form"].resetFields();
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 1500
                  });
                  that.dialogAddVisible = false;
                  that.addLoading = false;
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.dialogAddVisible = false;
                that.addLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.dialogAddVisible = false;
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    editPost() {
      var that = this;
      let para = Object.assign({}, that.form);
      para.noVip = 1;
      para.token = localStorage.getItem("api_token");
      this.addLoading = true;
      API.up_add_good_type(para)
        .then(
          function(result) {
            if (result.key == 1000) {
              that.$message.success({
                showClose: true,
                message: "修改成功",
                duration: 1500
              });
              that.dialogEditVisible = false;
              that.addLoading = false;
              that.search();
            } else if (result.key == 1001) {
              bus.$emit("goto", "/login");
            } else {
              that.$message.error({
                showClose: true,
                message: result.message || "登录失败",
                duration: 2000
              });
            }
          },
          function(err) {
            that.dialogEditVisible = false;
            that.addLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.dialogEditVisible = false;
          that.addLoading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    addPostDialog() {
      this.form.listPic = null;
      this.form.mainPic = null;
      this.form.index = 0;
      this.form.typeName = null;
      this.form.id = null;
      this.form.status = "1";
      if (this.backFirst == 2) {
        this.form.pid = this.filters.pid;
      }
      this.dialogAddVisible = true;
      this.getAllFirst();
    },
    backFirstM() {
      this.backFirst = 1;
      this.filters.pid = null;
      this.handleSearch();
    },
    showSecond(row) {
      this.backFirst = 2;
      this.filters.pid = row.id;
      this.handleSearch();
    },
    editPostDialog(row) {
      this.form.id = row.id;
      this.form.status = row.status.toString();
      this.form.listPic = row.listPic;
      this.form.mainPic = row.mainPic;
      this.form.id = row.id;
      this.form.typeName = row.title;
      this.form.index = row.orderIndex;
      this.form.pid = row.pid;
      this.dialogEditVisible = true;
      this.getAllFirst();
    },
    getAllFirst() {
      this.typeOptions = [];
      // if (this.typeOptions == null) {
      //   this.loading = true;
      //   //获取最新的大类列表
      //   var params = {
      //     page_num: 1,
      //     page_size: 100,
      //     infoType: 1,
      //     token: localStorage.getItem("api_token")
      //   };
      //   var that = this;
      //   API.good_first_type_list(params)
      //     .then(
      //       function(result) {
      //         that.loading = false;
      //         if (result.key == 1000) {
      //           if (result.result.list && result.result.list.length > 0) {
      //           }
      //           that.typeOptions = [
      //             {
      //               id: "-1",
      //               typeName: "无上级分类"
      //             }
      //           ];
      //           that.typeOptions = that.typeOptions.concat(result.result.list);
      //         } else if (result.key == 1001) {
      //           bus.$emit("goto", "/login");
      //         }
      //       },
      //       function(err) {
      //         that.loading = false;
      //         that.$message.error({
      //           showClose: true,
      //           message: err.toString(),
      //           duration: 2000
      //         });
      //       }
      //     )
      //     .catch(function(error) {
      //       that.loading = false;
      //       that.$message.error({
      //         showClose: true,
      //         message: "请求出现异常",
      //         duration: 2000
      //       });
      //     });
      // }
    },
    upHouseStatus(row, status) {
      let that = this;
      var m1 = "";
      var m2 = "";
      var m3 = "";
      var type = "";
      if (status == 1) {
        m1 = "确定取消上架该音视频分类吗？";
        m2 = "取消成功后，app就不显示该分类";
        m3 = "取消成功";
        type = "warning";
      } else if (status == 2) {
        m1 = "确定上架该音视频分类吗？";
        m2 = "上架成功后，app就会显示该分类";
        m3 = "上架成功";
        type = "success";
      } else {
        m1 = "确定删除该音视频分类吗？";
        m2 = "删除成功后，app和后台都不显示该分类";
        m3 = "删除成功";
        type = "error";
      }
      this.$confirm(m1, m2, { type: type })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.id,
            status: status
          };
          API.status_good_type(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  if (para.status == 3) {
                    that.typeOptions = null;
                  }
                  that.$message.success({
                    showClose: true,
                    message: m3,
                    duration: 1500
                  });
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;

      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        infoType: 8,
        noVip:1,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      if (
        that.filters.keyword &&
        that.filters.keyword != null &&
        that.filters.keyword != ""
      ) {
        params.keyword = that.filters.keyword;
      }
      that.loading = true;
      if (this.backFirst == 1) {
        API.good_first_type_list(params)
          .then(
            function(result) {
              that.loading = false;
              if (result.key == 1000) {
                that.total_num = result.result.count;
                that.total_page = result.result.allPageNumber;
                if (result.result.list && result.result.list.length > 0) {
                }
                that.tableData = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              }
            },
            function(err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      } else {
        params.pid = this.filters.pid;
        API.good_second_type_list(params)
          .then(
            function(result) {
              that.loading = false;
              if (result.key == 1000) {
                that.total_num = result.result.count;
                that.total_page = result.result.allPageNumber;
                if (result.result.list && result.result.list.length > 0) {
                }
                that.tableData = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              }
            },
            function(err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/courseTypeListOO.vue